import axios from 'axios';

// const url = `${window.location.protocol}//${window.location.host}/api`;
const url = 'https://telephone-api.idealagent.com';
// const url = 'http://localhost:8080';
export default axios.create({
  baseURL: url,
});
